<template>
  <p>
    An error occurred while uploading the {{ props.fileTypeLabel }}. Please retry or
    <a
      :data-testid="`email-customer-service-failed-to-upload-${props.dataTestId}`"
      class="underline text-royal-blue-100 hover:text-royal-blue-160 focus:text-royal-blue-160 visited:text-visited"
      :id="`linkCustomerServices${props.testId}`"
      href="mailto:manuscriptsupport@rsc.org?subject=RSC%20Submissions:%20Unable%20to%20upload%20submission%20files"
    >
      email customer services
    </a> if the issue persists.
  </p>
</template>

<script setup lang="ts">
const props = defineProps<{
  fileTypeLabel: string
  dataTestId: string
  testId: string
}>()
</script>
